var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 10.1999C8.14094 10.1999 9.55 8.79084 9.55 7.0499C9.55 5.30896 8.14094 3.8999 6.4 3.8999C4.65906 3.8999 3.25 5.30896 3.25 7.0499C3.25 8.79084 4.65906 10.1999 6.4 10.1999ZM8.56 11.0999H8.32656C7.74156 11.3812 7.09187 11.5499 6.4 11.5499C5.70812 11.5499 5.06125 11.3812 4.47344 11.0999H4.24C2.45125 11.0999 1 12.5512 1 14.3399V15.1499C1 15.8952 1.60469 16.4999 2.35 16.4999H10.45C11.1953 16.4999 11.8 15.8952 11.8 15.1499V14.3399C11.8 12.5512 10.3487 11.0999 8.56 11.0999ZM14.5 10.1999C15.9906 10.1999 17.2 8.99053 17.2 7.4999C17.2 6.00928 15.9906 4.7999 14.5 4.7999C13.0094 4.7999 11.8 6.00928 11.8 7.4999C11.8 8.99053 13.0094 10.1999 14.5 10.1999ZM15.85 11.0999H15.7431C15.3522 11.2349 14.9387 11.3249 14.5 11.3249C14.0612 11.3249 13.6478 11.2349 13.2569 11.0999H13.15C12.5762 11.0999 12.0475 11.2658 11.5834 11.533C12.2697 12.2727 12.7 13.2543 12.7 14.3399V15.4199C12.7 15.4818 12.6859 15.5408 12.6831 15.5999H17.65C18.3953 15.5999 19 14.9952 19 14.2499C19 12.509 17.5909 11.0999 15.85 11.0999V11.0999Z",
    fill: "#BE69C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommender);
export default __webpack_public_path__ + "static/media/recommender.b7553aa9147ce5879344054e1a9a401c.svg";
export { ForwardRef as ReactComponent };